import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { SITE, NAV_LINKS } from "@/lib/site";
import EkgLine from "@/components/EkgLine";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            style={{
                background: "var(--brand-dark)",
                color: "#e9e7e2",
                marginTop: "auto",
            }}
        >
            <EkgLine
                className="px-0"
                height={36}
                label="footer-ekg-divider"
            />
            <div
                className="brand-container"
                style={{
                    paddingTop: "3.5rem",
                    paddingBottom: "2.25rem",
                    display: "grid",
                    gap: "2.5rem",
                    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                }}
            >
                <div>
                    <img
                        src="/brand/logo-cropped-1024.png"
                        alt="CPR Paint & Coatings"
                        className="footer-logo-img"
                        style={{
                            display: "block",
                            background: "#fff",
                            padding: "0.85rem 1.1rem",
                            borderRadius: 10,
                            height: "auto",
                        }}
                        data-testid="footer-logo"
                    />
                    <p
                        style={{
                            marginTop: "1rem",
                            color: "#bdb9b1",
                            maxWidth: 320,
                            fontSize: "0.9375rem",
                            lineHeight: 1.6,
                        }}
                    >
                        Professional residential and commercial painting serving{" "}
                        {SITE.serviceAreaExtended}.
                    </p>
                </div>

                <div>
                    <h4
                        style={{
                            color: "#fff",
                            fontSize: "0.8125rem",
                            fontWeight: 700,
                            letterSpacing: "0.12em",
                            textTransform: "uppercase",
                            marginBottom: "1rem",
                        }}
                    >
                        Explore
                    </h4>
                    <ul
                        style={{
                            listStyle: "none",
                            padding: 0,
                            display: "flex",
                            flexDirection: "column",
                            gap: "0.55rem",
                        }}
                    >
                        {NAV_LINKS.map((l) => (
                            <li key={l.to}>
                                <Link
                                    to={l.to}
                                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                    style={{ color: "#d6d2c9" }}
                                >
                                    {l.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <h4
                        style={{
                            color: "#fff",
                            fontSize: "0.8125rem",
                            fontWeight: 700,
                            letterSpacing: "0.12em",
                            textTransform: "uppercase",
                            marginBottom: "1rem",
                        }}
                    >
                        Contact
                    </h4>
                    <ul
                        style={{
                            listStyle: "none",
                            padding: 0,
                            display: "flex",
                            flexDirection: "column",
                            gap: "0.7rem",
                            color: "#d6d2c9",
                            fontSize: "0.9375rem",
                        }}
                    >
                        <li
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                            }}
                        >
                            <Phone size={16} color="var(--brand-red)" />
                            <a
                                href={`tel:${SITE.phoneLink}`}
                                data-testid="footer-phone"
                            >
                                {SITE.phoneDisplay}
                            </a>
                        </li>
                        <li
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                            }}
                        >
                            <Mail size={16} color="var(--brand-red)" />
                            <a
                                href={`mailto:${SITE.email}`}
                                data-testid="footer-email"
                            >
                                {SITE.email}
                            </a>
                        </li>
                        <li
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                            }}
                        >
                            <MapPin size={16} color="var(--brand-red)" />
                            <span data-testid="footer-address">
                                {SITE.address}
                            </span>
                        </li>
                        <li
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                            }}
                        >
                            <Clock size={16} color="var(--brand-red)" />
                            <span data-testid="footer-hours">{SITE.hours}</span>
                        </li>
                    </ul>
                </div>

                <div>
                    <h4
                        style={{
                            color: "#fff",
                            fontSize: "0.8125rem",
                            fontWeight: 700,
                            letterSpacing: "0.12em",
                            textTransform: "uppercase",
                            marginBottom: "1rem",
                        }}
                    >
                        Trust
                    </h4>
                    <ul
                        style={{
                            listStyle: "none",
                            padding: 0,
                            color: "#d6d2c9",
                            fontSize: "0.9375rem",
                            display: "flex",
                            flexDirection: "column",
                            gap: "0.55rem",
                        }}
                    >
                        <li>Licensed</li>
                        <li>Fully insured</li>
                        <li>Experienced crews</li>
                        <li>Free written estimates</li>
                    </ul>
                </div>
            </div>

            <div
                style={{
                    borderTop: "1px solid #2a2a2a",
                    paddingTop: "1.25rem",
                    paddingBottom: "5rem",
                }}
            >
                <div
                    className="brand-container"
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "0.5rem",
                        justifyContent: "space-between",
                        color: "#9b988f",
                        fontSize: "0.8125rem",
                    }}
                >
                    <span data-testid="footer-copyright">
                        © {year} {SITE.copyrightLine}. All rights reserved.
                    </span>
                    <span>Proudly serving Utah and the surrounding states.</span>
                </div>
            </div>
        </footer>
    );
}
